export { default } from './BottomSlider';
